// extracted by mini-css-extract-plugin
module.exports = {"sectionFeatures":"SectionFeatures_sectionFeatures_i66eo"};